import React from 'react';
import { useState, useRef, useEffect} from 'react';
import './reservationTriplePicker.css';


import Datepicker from '../common/Datepicker/Datepicker.jsx';

function ReservationTriplePickerRealtime({

}) {
    if (typeof reservationData == 'undefined') {
        return null;
    }

    if (! Array.isArray(reservationData.guestsOptions) || reservationData.guestsOptions.length == 0) {
        return null;
    }

    const defaultNumGuest = reservationData.guestsOptions.some((option) => String(option) === '2')
        ? '2'
        : String(reservationData.guestsOptions[0]);

    const [showDatepicker, setShowDatepicker]   = useState(false);
    const [numGuest, setNumGuest] = useState(defaultNumGuest);  // default to 2 if exists, otherwise default to first option
    const [selectedDate, setSelectedDate] = useState('');
    const [selectedTime, setSelectedTime] = useState('');
    const [selectedMenuId, setSelectedMenuId] = useState('');
    const [guestTechHoldId, setGuestTechHoldId] = useState('');
    const [guestTechHoldExpiresAt, setGuestTechHoldExpiresAt] = useState('');
    const [guestTechHoldCreatedAt, setGuestTechHoldCreatedAt] = useState('');
    const [availabilityCheckResponse, setAvailabilityCheckResponse] = useState(reservationData.checkoutError);   // null for check to do.  check happen when data/guests are picked
    const [showAvailabilityError, setShowAvailabilityError] = useState(reservationData.checkoutError ? true : false); 
    const [slotPage, setSlotPage] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [showMenuModal, setShowMenuModal] = useState(false);
    const [pendingMenuId, setPendingMenuId] = useState('');
    const [expandedMenuDescs, setExpandedMenuDescs] = useState({});
    const [descOverflows, setDescOverflows] = useState({});
    const guestSelectRef = useRef(null);
    const menuModalRef = useRef(null);
    //const [showConfirmError, setShowConfirmError] = useState(false);

    
    let slotsPerPage = 9;
    let rd = reservationData;
    let productId = reservationData.productId;
    const programId = Number(reservationData.programId);
    const isGuestTechProgram = (programId == 16);
    const isSevenRoomsProgram = (programId == 19);
    const isTenGroupProgram = (programId == 21);
    const isAvvailV2Layout = Boolean(reservationData.isAvvailV2Layout);
    const enable7RExclusivity = Boolean(reservationData.enable7RExclusivity);
    const exclusiveSlotName = 'exclusive';

    function getSlotIdentifier(slot) {
        // TEN Dining: Use booking token (unique per slot) + datetime to differentiate
        // slots with same time but different types (e.g., 8:00 AM - Deposit Required vs 8:00 AM - No Fee)
        if (isTenGroupProgram && slot.access_persistent_id) {
            return slot.real_datetime_of_slot + '||' + slot.access_persistent_id;
        }
        
        if (enable7RExclusivity) {
             return slot.option_id || (slot.slot_option_id
            ? slot.real_datetime_of_slot + '||' + slot.slot_option_id
            : slot.real_datetime_of_slot);
        }
        if (isSevenRoomsProgram && slot.slot_option_id) {
            return slot.real_datetime_of_slot + '||' + slot.slot_option_id;
        }
        return slot.option_id || slot.real_datetime_of_slot;
    }

    function getSlotDisplayName(slot) {
        if (isTenGroupProgram) {
            return slot?.slot_type || 'Dining Room';
        }
        
        if (enable7RExclusivity && isSevenRoomsProgram) {
            return slot?.slot_name ||  'Dining Room';
        }
        return slot?.seating_area?.name;
    }

    function getSelectedSlot() {
        if (!availabilityCheckResponse || availabilityCheckResponse.result != 1 || !Array.isArray(availabilityCheckResponse.timeslots)) {
            return null;
        }

        for (let i = 0; i < availabilityCheckResponse.timeslots.length; i++) {
            const slot = availabilityCheckResponse.timeslots[i];
            if (getSlotIdentifier(slot) == selectedTime) {
                return slot;
            }
        }

        return null;
    }

    function _selectedTimeChangedUIUpdate(t, menuId) {
        let btn =  document.getElementById('buynow-button');
        if (btn) {
            // Find current slot to check if menus exist
            let needsMenu = false;
            if (t && availabilityCheckResponse && Array.isArray(availabilityCheckResponse.timeslots)) {
                for (let i = 0; i < availabilityCheckResponse.timeslots.length; i++) {
                    const s = availabilityCheckResponse.timeslots[i];
                    if (getSlotIdentifier(s) == t && Array.isArray(s.menus) && s.menus.length > 0) {
                        needsMenu = true;
                        break;
                    }
                }
            }
            if (t && (!needsMenu || menuId)) {
                btn.classList.remove('disabled')
            } else {
                btn.classList.add('disabled')
            }
        }
    }

    function numGuestChanged(e) {
        if (! reservationData.isAjax) {
            return;
        }

        let n = String(e.target.value);
        setNumGuest(n);

        if (selectedDate) {
            setSelectedTime('');
            setSelectedMenuId('');
            //setAvailabilityCheckResponse(null);
            //setSlotPage(0);
            getRealTimeAvailability(productId, selectedDate, n);
        }
    }

    function openNativeSelectOnKeyboard(event) {
        const isOpenKey = event.key === 'Enter' || event.key === ' ' || event.key === 'ArrowDown';
        if (! isOpenKey) {
            return;
        }

        const select = event.currentTarget;
        if (! select) {
            return;
        }

        if (typeof select.showPicker === 'function') {
            event.preventDefault();
            select.showPicker();
            return;
        }

        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            select.focus();
            select.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
            select.click();
        }
    }

    function clandarBtnClicked(e) {
        if (! reservationData.isAjax) {
            return;
        }
        
        setShowDatepicker(true);

        setTimeout(function(){
            let datecell = document.querySelector('.rtp_date_cell.active');
            if (datecell) {
                datecell.focus();
            }
        }, 0);
    }

    function onDatePicked(date) {
        if (! reservationData.isAjax) {
            return;
        }

        setSelectedDate(date);
        setSelectedTime('');
        setSelectedMenuId('');
        setShowDatepicker(false);
        //setAvailabilityCheckResponse(null);
        //setSlotPage(0);

        getRealTimeAvailability(productId, date, numGuest);
    }

    function timeClicked(e) {
        if (! reservationData.isAjax) {
            return;
        }
        let t = e.currentTarget.dataset.timeslot;
        setSelectedTime(t);
        setGuestTechHoldId(''); // clear any prior hold when a new time is selected
        setGuestTechHoldExpiresAt('');
        setGuestTechHoldCreatedAt('');

        // Find the clicked slot to check for menus
        let clickedSlot = null;
        if (availabilityCheckResponse && Array.isArray(availabilityCheckResponse.timeslots)) {
            for (let i = 0; i < availabilityCheckResponse.timeslots.length; i++) {
                const s = availabilityCheckResponse.timeslots[i];
                if (getSlotIdentifier(s) == t) {
                    clickedSlot = s;
                    break;
                }
            }
        }

        if (clickedSlot && Array.isArray(clickedSlot.menus) && clickedSlot.menus.length > 0) {
            if (clickedSlot.menus.length === 1) {
                // Single menu — auto-select, no modal needed
                setSelectedMenuId(String(clickedSlot.menus[0].id));
                setPendingMenuId(String(clickedSlot.menus[0].id));
            } else {
                // Multiple menus — clear selection; user picks via modal
                setSelectedMenuId('');
                setPendingMenuId('');
            }
            setShowMenuModal(false);
        } else {
            // No menus array — fall back to data-menuid attribute
            setSelectedMenuId(e.currentTarget.dataset.menuid || '');
        }
    }

    function menuClicked(menuId) {
        setSelectedMenuId(String(menuId));
    }

    function onOpenMenuModal() {
        setPendingMenuId(selectedMenuId);
        setShowMenuModal(true);
    }

    function onCloseMenuModal() {
        setShowMenuModal(false);
    }

    function onConfirmMenuSelection() {
        if (pendingMenuId) {
            setSelectedMenuId(pendingMenuId);
        }
        setShowMenuModal(false);
    }

    function onMenuModalKeyDown(e) {
        if (e.key === 'Escape') {
            onCloseMenuModal();
            return;
        }
        if (e.key === 'Tab') {
            const focusable = menuModalRef.current?.querySelectorAll(
                'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
            );
            if (!focusable || focusable.length === 0) return;
            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            if (e.shiftKey) {
                if (document.activeElement === first) { e.preventDefault(); last.focus(); }
            } else {
                if (document.activeElement === last) { e.preventDefault(); first.focus(); }
            }
        }
    }

    function getSelectedSlotMenus() {
        const slot = getSelectedSlot();
        if (slot && Array.isArray(slot.menus) && slot.menus.length > 0) {
            return slot.menus;
        }
        return null;
    }

    function getOccasionInput() {
        return document.querySelector('input[name="CartItemSocialInfo[occasion]"]');
    }

    function getGuestTechMetaFromInput() {
        const occasionInput = getOccasionInput();
        if (! occasionInput || ! occasionInput.value) {
            return null;
        }

        try {
            return JSON.parse(occasionInput.value);
        } catch (error) {
            return null;
        }
    }

    function syncGuestTechMetaToSelectedSlot() {
        const selectedSlot = getSelectedSlot();
        const occasionInput = getOccasionInput();

        setGuestTechHoldId('');
        setGuestTechHoldExpiresAt('');
        setGuestTechHoldCreatedAt('');

        if (occasionInput) {
            if (selectedSlot && selectedSlot.option_id) {
                occasionInput.value = JSON.stringify({
                    option_id: selectedSlot.option_id,
                    selected_datetime: selectedSlot.real_datetime_of_slot || ''
                });
            } else {
                occasionInput.value = '';
            }
        }
    }

    function syncPartnerReservationMetaToSelectedSlot() {
        const selectedSlot = getSelectedSlot();
        const occasionInput = getOccasionInput();

        if (! occasionInput) {
            return;
        }

        if ((isSevenRoomsProgram || isTenGroupProgram) && selectedSlot && selectedSlot.access_persistent_id) {
            occasionInput.value = JSON.stringify({
                access_persistent_id: selectedSlot.access_persistent_id
            });
        } else if (isSevenRoomsProgram || isTenGroupProgram) {
            occasionInput.value = '';
        }
    }

    function releaseGuestTechHoldFromPdp(holdId) {
        const formData = new FormData();
        formData.append('holdId', holdId);
        formData.append('source', 'pdp-pageshow');
        formData.append('programId', reservationData.programId);
        formData.append('stk', g_ifonlycsrftoken);

        return fetch((g_is_mobile ? '/m' : '') + '/product/ReleaseHold', {
            method: 'POST',
            body: formData,
            credentials: 'same-origin'
        }).then((response) => response.json())
        .catch(() => null);
    }

    function _getTimeSlotCss(slot, selectedTime, index){
        let selected =  (getSlotIdentifier(slot) == selectedTime);
        let css = {
            borderColor: reservationData.siteColors.primaryButtonBackground || reservationData.siteColors.primary
        };
        if (selected) {
            css.background = reservationData.siteColors.primaryButtonBackground || reservationData.siteColors.primary
            css.color = reservationData.siteColors.primaryButtonFontColor || reservationData.siteColors.white;
            
        }

        let page = Math.floor(index / slotsPerPage);
        if (page == slotPage) {
            css.display = 'block';
        } else {
            css.display = 'none';
        }
        return css;
    }

    function onOverlayPicked(e) {
        if (e.target.classList.contains('datepicker_ra_overlay')) {
            setShowDatepicker(false);
        }
    }

    // senario: 'check' or 'confirm'.  confirm not used now.
    // check happens when date/guests are picked
    // confirm happens when user 'start reservation'
    function getRealTimeAvailability(productId, date, partySize, senario) {
        if (typeof senario == 'undefined') { senario = 'check'}
        const normalizedPartySize = String(partySize ?? numGuest ?? defaultNumGuest);
        const formData = new FormData();
        formData.append('productId', productId);
        formData.append('date', date);
        formData.append('partySize', normalizedPartySize);
        formData.append('stk', g_ifonlycsrftoken);
        let actionName = 'GetRealTimeVenueAvailability';
        let url =  (g_is_mobile ? '/m' : '') + '/product/' + actionName;

        setIsLoading(true);
        setTimeout(function() {
            document.querySelector('.loading_msg').innerText= reservationData.strings.loadingMsg
        }, 10);
        fetch(url, {
            method: 'POST',
            body: formData 
        }).then(Result => Result.json())
        .then(data => {
            if (typeof(localStorage) != 'undefined' && localStorage.fakeNoAavai == '1' ) {
                data.timeslots = [];
            }
            if (typeof(localStorage) != 'undefined' && localStorage.fakeAavaiResult ) {                     // '0' to fake error. '' to reset.
                data.result = localStorage.fakeAavaiResult * 1;
                data.request_id = 'sdkfjslkdjflsdjfljdlfjsdljfsdljfklsjfklsdjfksdjfkdjflksdjfklsdjfkjsdkfjsdkjfkdsjflksjdfkjskfjsfdjlsdjflsjflk';
            }
            if (typeof(localStorage) != 'undefined' && localStorage.fakeTimeSlots == '1') {
                let slots = [];
                for (let i=10; i<40; i++) {
                    let slot = {
                        real_datetime_of_slot: '2025-09-19 12:' + i +  ':00', 
                        time_display: "12:" + i + " pm"
                    }
                    slots.push(slot);
                }
                data.timeslots = slots;
            }

            if (senario == 'check') {   
                setAvailabilityCheckResponse(data);
                setSlotPage(0);
                if (data.result == 0) {
                    setShowAvailabilityError(true);
                    setTimeout(function() {
                        //document.querySelector('.rtp_availability_err_overlay .try_again_btn').focus();
                        document.querySelector('.rtp_availability_err_overlay .rtp_avail_error_msg').focus();
                    }, 10);
                } else {
                    if (data.timeslots.length == 0) {
                        setTimeout(function() {
                            let msg_dom = document.querySelector('.rtp_no_avail_msg');
                            //msg_dom.setAttribute('aria-live', 'assertive');
                            msg_dom.focus();
                        }, 10);
                    } else {
                        setTimeout(function() {
                            let msg_dom = document.querySelector('.rtp_timeslots_div .timeslot_btn');
                            //msg_dom.setAttribute('aria-live', 'assertive');
                            msg_dom.focus();
                        }, 10);
                    }
                }
            }
            /*
            else if (senario == 'confirm') {
                let confirmed = false;
                if (data.result == 1 && Array.isArray(data.timeslots)) {
                    for (let i in data.timeslots) {
                        let slot = data.timeslots[i];
                        if (slot.real_datetime_of_slot == selectedTime) {
                            confirmed = true;
                            break;
                        }
                    }
                }
                console.log('confirm');
                if (! confirmed) {
                    setShowConfirmError(true);
                }
            }
            */
        })
        .catch(error => {
            alertEx('Error in checking venue.');
            setAvailabilityCheckResponse(null);
            setSlotPage(0);
        })
        .finally(() => {
            setIsLoading(false);
            setTimeout(function() {
                document.querySelector('.loading_msg').innerText=''
            }, 10);
        });
    }

    function getDateDisplay(date) {
        if (typeof(g_locale) != 'undefined' && date != '') {
            return g_locale.formatDate(date);
        }
        return date;
    }

    function getTimeDisplay(time, time_display) {
        if (time == undefined || time == '') {
            return time_display;
        }
        if (typeof(g_locale) != 'undefined' && time != '') {
            return g_locale.formatTime(time);
        }
        return time_display;
    }

    function refIdClicked() {
        let refId_dom = document.querySelector('.rtp_ref_id_span');
        if (refId_dom.classList.contains('expanded')) {
            refId_dom.classList.remove('expanded');
        }
        else {
            refId_dom.classList.add('expanded');
        }
    }

    function getAvailabilityErrorMsg(availabilityCheckResponse) {
        if (availabilityCheckResponse.origin == 'sessionVar') {
            let msg = availabilityCheckResponse.message || '';
            if (availabilityCheckResponse.httpCode == '400' && msg.includes('phone number is required to book')) {
                return rd.strings.checkoutError400;
            }
            if (isGuestTechProgram) {
                return rd.strings.guestTechInventoryErrorMessage || rd.strings.checkoutErrorDuplicate || rd.strings.checkoutError;
            }
            return rd.strings.checkoutError;
        }
        return rd.strings.availabilityError;
    }

    function getAvailabilityErrorTitle(availabilityCheckResponse) {
        if (! availabilityCheckResponse || availabilityCheckResponse.origin != 'sessionVar') {
            return '';
        }

        if (isGuestTechProgram) {
            return rd.strings.guestTechInventoryErrorHeader || '';
        }

        return '';
    }

    function getAvailabilityErrorActionText(availabilityCheckResponse) {
        if (
            availabilityCheckResponse &&
            availabilityCheckResponse.origin == 'sessionVar' &&
            isGuestTechProgram
        ) {
            return rd.strings.guestTechInventoryErrorButton || rd.strings.tryAgain;
        }

        return rd.strings.tryAgain;
    }

    function onCloseAvailabilityError() {
        setSelectedDate('');
        setSelectedTime('');
        setSelectedMenuId('');
        setAvailabilityCheckResponse(null);
        setSlotPage(0);

        setShowAvailabilityError(false);
    }

    function onReturnHome(e) {
        e.preventDefault();
        e.stopPropagation();
        setShowAvailabilityError(false);
        if (rd.accessCodeRedirectUrl) {
            window.location.href = rd.accessCodeRedirectUrl;
        } else {
            window.location.href = '/';
        }
    }

    function onPreSlotPageClick(e) {
        const displayableSlots = getDisplayableSlots();
        if (displayableSlots && displayableSlots.length > 0) {
            if (slotPage > 0) {
                setSlotPage(slotPage - 1);
            }
        }
    }

    function onNextSlotPageClick(e) {
        const displayableSlots = getDisplayableSlots();
        if (displayableSlots && displayableSlots.length > 0) {
            let maxPage = Math.ceil(displayableSlots.length / slotsPerPage);
            if (slotPage < maxPage - 1) {
                setSlotPage(slotPage + 1);
            }
        }
    }

    function onCloseConfirmError() {
        setSelectedDate('');
        setSelectedTime('');
        setSelectedMenuId('');
        setAvailabilityCheckResponse(null);
        setSlotPage(0);
        setShowConfirmError(false);
    }

    function _getPreSlotPageClass() {
        return (slotPage == 0 ? 'deactivated' : '') ;
    }

    function _getNextSlotPageClass() {
        const displayableSlots = getDisplayableSlots();
        if (displayableSlots && displayableSlots.length > 0) {
            let maxPage = Math.ceil(displayableSlots.length / slotsPerPage);
            if (slotPage >= maxPage - 1) {
                return 'deactivated';
            } else {
                return '';
            }
        }
        return 'deactivated';
    }

    function isTimeSlotExclusive (slot) {
        if (slot && slot.is_exclusive) {
            return true;
        }
        return false;
    }

    function getDisplayableSlots() {
        if (!availabilityCheckResponse || availabilityCheckResponse.result != 1 || !Array.isArray(availabilityCheckResponse.timeslots)) {
            return [];
        }
        
        // For TEN Dining: Backend already filters for NoPayment, so show all slots
        // payment_rule will be "NoPayment" (string) or null for older data
        if (isTenGroupProgram) {
            // All slots from backend should already be NoPayment-filtered
            return availabilityCheckResponse.timeslots;
        }
        
        // For non-TEN programs, show all slots
        return availabilityCheckResponse.timeslots;
    }

    function getCurrentPageSlots() {
        const displayableSlots = getDisplayableSlots();
        const startIndex = slotPage * slotsPerPage;
        const endIndex = startIndex + slotsPerPage;
        return displayableSlots.slice(startIndex, endIndex);
    }

    function _getTimeSlotCssForCurrentPage(slot, selectedTime, pageIndex) {
        let selected = (getSlotIdentifier(slot) == selectedTime);
        let css = {
            borderColor: reservationData.siteColors.primaryButtonBackground || reservationData.siteColors.primary,
            display: 'block'  // Always display on current page
        };
        if (selected) {
            css.background = reservationData.siteColors.primaryButtonBackground || reservationData.siteColors.primary
            css.color = reservationData.siteColors.primaryButtonFontColor || reservationData.siteColors.white;
        }
        return css;
    }

    useEffect(() => {
        const onConfirmErrorEvent = () => {
            //console.log('confirm error handler called');
            onCloseConfirmError();
        }

        if (document && document.confrimAvaiHandlerAdded != 1) {
            //console.log('----- add listener');
            document.confrimAvaiHandlerAdded = 1;
            document.addEventListener("confirmAvailabilityError", onConfirmErrorEvent);
        }

        return () => {
            if ( document.confrimAvaiHandlerAdded == 1) {
                document.confrimAvaiHandlerAdded = undefined;
                document.removeEventListener("confirmAvailabilityError", onConfirmErrorEvent);
            }
        
        }

    }, [selectedTime]);


    useEffect(() => {
        syncPartnerReservationMetaToSelectedSlot();
    }, [selectedTime, availabilityCheckResponse, isSevenRoomsProgram, isTenGroupProgram]);


    useEffect(() => {
        function onPageShow(event) {
            if (! event.persisted || ! selectedDate || ! isGuestTechProgram) {
                return;
            }

            const guestTechMeta = getGuestTechMetaFromInput();
            const holdId = guestTechMeta && guestTechMeta.hold_id ? guestTechMeta.hold_id : '';

            syncGuestTechMetaToSelectedSlot();

            if (holdId) {
                setIsLoading(true);
                releaseGuestTechHoldFromPdp(holdId)
                    .finally(() => {
                        getRealTimeAvailability(productId, selectedDate, numGuest);
                    });
                return;
            }

            getRealTimeAvailability(productId, selectedDate, numGuest);
        }

        window.addEventListener('pageshow', onPageShow);

        return () => {
            window.removeEventListener('pageshow', onPageShow);
        };
    }, [selectedDate, numGuest, productId, isGuestTechProgram, availabilityCheckResponse]);


    useEffect(() => {
        if (reservationData.isAjax && reservationData.checkoutError) {
            setTimeout(function() {
                //document.querySelector('.rtp_availability_err_overlay .try_again_btn').focus();
                let el = document.querySelector('.rtp_availability_err_overlay .rtp_avail_error_msg');
                if (el) {
                    el.focus();
                }
            }, 10);
        }
    }, []);

    _selectedTimeChangedUIUpdate(selectedTime, selectedMenuId);

    let primaryBtnColor = rd.siteColors.primaryButtonBackground || rd.siteColors.primary;
    let primaryBtnFontColor = rd.siteColors.primaryButtonFontColor || rd.siteColors.white;
    let container_border_css = [SG.BD_2, SG.NO_BD_LEFT, SG.NO_BD_RIGHT, SG.NO_BD_TOP, SG.F_BODY].join(" ");
    let btnStyle = {backgroundColor: primaryBtnColor, color: primaryBtnFontColor };
    let selectedSlot = getSelectedSlot();
    let selectedScheduleDateTime = selectedSlot && selectedSlot.real_datetime_of_slot ? selectedSlot.real_datetime_of_slot : selectedTime?.split('||')[0];
    let reservationOccasionMeta = '';

    if (isGuestTechProgram && selectedSlot) {
        if (guestTechHoldId) {
            reservationOccasionMeta = JSON.stringify({
                hold_id: guestTechHoldId,
                hold_expires_at: guestTechHoldExpiresAt || undefined,
                hold_created_at: guestTechHoldCreatedAt || undefined,
                selected_datetime: selectedScheduleDateTime || undefined
            });
        } else if (selectedSlot.option_id) {
            reservationOccasionMeta = JSON.stringify({
                option_id: selectedSlot.option_id,
                selected_datetime: selectedScheduleDateTime || undefined
            });
        }
    } else if ((isSevenRoomsProgram || isTenGroupProgram) && selectedSlot && selectedSlot.access_persistent_id) {
        reservationOccasionMeta = JSON.stringify({
            access_persistent_id: selectedSlot.access_persistent_id
        });
    }

    window.rtp_setIsLoading = setIsLoading;
    window.rtp_setGuestTechHoldId = setGuestTechHoldId;
    window.rtp_setGuestTechHoldExpiresAt = setGuestTechHoldExpiresAt;
    window.rtp_setGuestTechHoldCreatedAt = setGuestTechHoldCreatedAt;


    return (
        <>
            <div className={'rtp_container realtime ' + (isAvvailV2Layout || enable7RExclusivity || isTenGroupProgram ? 'avvail-v2-layout ' : '') +  container_border_css} >

                <div className='rtp_pd_row'>
                    <div className="guest_select_div">
                        <label htmlFor="CartItemSocialInfo_numGuests" >{rd.strings.guestsSelectLable}</label>
                        <select
                            id="CartItemSocialInfo_numGuests"
                            name="CartItemSocialInfo[numGuests]"
                            className={"guest_select " + SG.BD_PRIMARY + ' ' + SG.RC_BD_RADIUS} 
                            ref={guestSelectRef}
                            style={{borderColor: primaryBtnColor}}
                            value={numGuest}
                            onChange={numGuestChanged}
                            onKeyDown={openNativeSelectOnKeyboard}
                            aria-label={rd.strings.guestsSelectLable}
                        >
                            {reservationData.guestsOptions.map(
                                (num, index) => { 
                                    return (
                                        <option key={'numGuest_' + num} value={num}   >
                                            {num}
                                        </option>
                                    )
                                }
                            )}
                        </select>

                        <svg className='select_icon' width="20" height="20" viewBox="0 0 500 500" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M83.3909 183.725L106.609 160.275L246.363 298.646L382.755 160.411L406.245 183.589L246.636 345.354L83.3909 183.725Z" fill={primaryBtnColor}/>
                        </svg>
                    </div>

                    <div  className="calendar_btn_div">
                        <label htmlFor="rpt_calendar_btn" >{rd.strings.dateSelectLabel}</label>
                        <button type="button" id="rpt_calendar_btn" className="calendar_btn clean_button" onClick={clandarBtnClicked}
                            style={{borderColor: primaryBtnColor}}
                            aria-label={rd.strings.dateSelectLabel}
                        >
                            <span className={SG.F_BODY}>
                                {selectedDate ? getDateDisplay(selectedDate) : rd.strings.selectADate}
                            </span>

                            <svg width="23" height="25" viewBox="0 0 23 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M9.38525 4.27552C9.38525 2.99109 8.28798 1.9109 6.88525 1.9109V0.910904C8.79624 0.910904 10.3853 2.39579 10.3853 4.27552C10.3853 5.28069 9.92671 6.1785 9.20985 6.79103L8.56023 6.03077C9.07111 5.59424 9.38525 4.96736 9.38525 4.27552ZM1.88525 5.9109C1.88525 5.08248 2.55683 4.4109 3.38525 4.4109H7.88525V3.4109H3.38525C2.00454 3.4109 0.885254 4.53019 0.885254 5.9109V21.9109C0.885254 23.2916 2.00454 24.4109 3.38525 24.4109H20.3853C21.766 24.4109 22.8853 23.2916 22.8853 21.9109V5.9109C22.8853 4.53019 21.766 3.4109 20.3853 3.4109H19.4686V4.4109H20.3853C21.2137 4.4109 21.8853 5.08248 21.8853 5.9109V21.9109C21.8853 22.7393 21.2137 23.4109 20.3853 23.4109H3.38525C2.55683 23.4109 1.88525 22.7393 1.88525 21.9109V5.9109ZM11.4186 4.4109H16.0853V3.4109H11.4186V4.4109ZM3.88525 9.4109H19.8853V8.4109H3.88525V9.4109ZM14.8853 1.9109C16.288 1.9109 17.3853 2.99109 17.3853 4.27552C17.3853 4.96736 17.0711 5.59424 16.5602 6.03077L17.2098 6.79103C17.9267 6.1785 18.3853 5.28069 18.3853 4.27552C18.3853 2.39579 16.7962 0.910904 14.8853 0.910904V1.9109ZM4.88525 12.4109V14.4109H6.88525V12.4109H4.88525ZM4.38525 11.4109C4.10911 11.4109 3.88525 11.6348 3.88525 11.9109V14.9109C3.88525 15.187 4.10911 15.4109 4.38525 15.4109H7.38525C7.6614 15.4109 7.88525 15.187 7.88525 14.9109V11.9109C7.88525 11.6348 7.6614 11.4109 7.38525 11.4109H4.38525ZM4.88525 20.4109V18.4109H6.88525V20.4109H4.88525ZM3.88525 17.9109C3.88525 17.6348 4.10911 17.4109 4.38525 17.4109H7.38525C7.6614 17.4109 7.88525 17.6348 7.88525 17.9109V20.9109C7.88525 21.187 7.6614 21.4109 7.38525 21.4109H4.38525C4.10911 21.4109 3.88525 21.187 3.88525 20.9109V17.9109ZM10.8853 12.4109V14.4109H12.8853V12.4109H10.8853ZM10.3853 11.4109C10.1091 11.4109 9.88525 11.6348 9.88525 11.9109V14.9109C9.88525 15.187 10.1091 15.4109 10.3853 15.4109H13.3853C13.6614 15.4109 13.8853 15.187 13.8853 14.9109V11.9109C13.8853 11.6348 13.6614 11.4109 13.3853 11.4109H10.3853ZM10.8853 20.4109V18.4109H12.8853V20.4109H10.8853ZM9.88525 17.9109C9.88525 17.6348 10.1091 17.4109 10.3853 17.4109H13.3853C13.6614 17.4109 13.8853 17.6348 13.8853 17.9109V20.9109C13.8853 21.187 13.6614 21.4109 13.3853 21.4109H10.3853C10.1091 21.4109 9.88525 21.187 9.88525 20.9109V17.9109ZM16.8853 12.4109V14.4109H18.8853V12.4109H16.8853ZM16.3853 11.4109C16.1091 11.4109 15.8853 11.6348 15.8853 11.9109V14.9109C15.8853 15.187 16.1091 15.4109 16.3853 15.4109H19.3853C19.6614 15.4109 19.8853 15.187 19.8853 14.9109V11.9109C19.8853 11.6348 19.6614 11.4109 19.3853 11.4109H16.3853ZM16.8853 20.4109V18.4109H18.8853V20.4109H16.8853ZM15.8853 17.9109C15.8853 17.6348 16.1091 17.4109 16.3853 17.4109H19.3853C19.6614 17.4109 19.8853 17.6348 19.8853 17.9109V20.9109C19.8853 21.187 19.6614 21.4109 19.3853 21.4109H16.3853C16.1091 21.4109 15.8853 21.187 15.8853 20.9109V17.9109Z" fill={primaryBtnColor}/>
                            </svg>

                        </button> 
                    </div>
                </div>

                {
                    showAvailabilityError &&
                    <div className={`rtp_availability_err_overlay rtp_overlay ifonly_overlay ${SG.F_BODY}`}  style={{display:'block'}} onClick={e => e.stopPropagation()}>
                        <div className={`ifonly_pop ${SG.RC_BD_RADIUS}`} onClick={e => e.stopPropagation()}>
                            <button type="button" className="closebtn" onClick={onCloseAvailabilityError} aria-label={rd.strings.close}>
                                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16.2208 1.38562L9.60463 8.078L16.2208 14.7714L15.1154 15.8885L8.49916 9.19519L1.88393 15.8885L0.779434 14.7714L7.39467 8.078L0.779434 1.38562L1.88393 0.267456L8.49916 6.95984L15.1154 0.267456L16.2208 1.38562Z" fill="#141413"/>
                                </svg>
                            </button>

                            <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginBottom:'10px'}} aria-label={rd.strings.attention}>
                                <path fillRule="evenodd" clipRule="evenodd" d="M25 7.8125C15.5076 7.8125 7.8125 15.5076 7.8125 25C7.8125 34.4924 15.5076 42.1875 25 42.1875C34.4924 42.1875 42.1875 34.4924 42.1875 25C42.1875 15.5076 34.4924 7.8125 25 7.8125ZM4.6875 25C4.6875 13.7817 13.7817 4.6875 25 4.6875C36.2183 4.6875 45.3125 13.7817 45.3125 25C45.3125 36.2183 36.2183 45.3125 25 45.3125C13.7817 45.3125 4.6875 36.2183 4.6875 25ZM25 17.1875C25.8629 17.1875 26.5625 17.8871 26.5625 18.75V26.5625C26.5625 27.4254 25.8629 28.125 25 28.125C24.1371 28.125 23.4375 27.4254 23.4375 26.5625V18.75C23.4375 17.8871 24.1371 17.1875 25 17.1875ZM23.4375 32.8125C23.4375 31.9496 24.1371 31.25 25 31.25H25.0156C25.8786 31.25 26.5781 31.9496 26.5781 32.8125V32.8281C26.5781 33.6911 25.8786 34.3906 25.0156 34.3906H25C24.1371 34.3906 23.4375 33.6911 23.4375 32.8281V32.8125Z" fill={primaryBtnColor}/>
                            </svg>

                            {availabilityCheckResponse && getAvailabilityErrorTitle(availabilityCheckResponse) &&
                                <div className="rtp_confirm_error_title">{getAvailabilityErrorTitle(availabilityCheckResponse)}</div>
                            }

                            {availabilityCheckResponse &&
                                <div className="rtp_avail_error_msg" tabIndex="0" dangerouslySetInnerHTML={{ __html: getAvailabilityErrorMsg(availabilityCheckResponse) }} ></div>
                            }

                            {availabilityCheckResponse && availabilityCheckResponse.request_id &&
                                <div className="ref_row" aria-live="assertive">
                                    <span>Ref ID:</span>
                                    <span className="rtp_ref_id_span" onClick={refIdClicked}>{availabilityCheckResponse.request_id}</span>
                                </div>
                            }

                            <div className="btn_row">
                                <button type="button" className={'return_home_btn ' + SG.BD_PRIMARY } style={btnStyle} onClick={onReturnHome}>
                                    {rd.strings.returnToHome}
                                </button>
                                <button type="button" className={'try_again_btn ' + SG.BD_PRIMARY } style={btnStyle} onClick={onCloseAvailabilityError}>
                                    {getAvailabilityErrorActionText(availabilityCheckResponse)}
                                </button>
                            </div>
                        </div>
                    </div>
                }

                {
                    availabilityCheckResponse && availabilityCheckResponse.result == 1 && Array.isArray(availabilityCheckResponse.timeslots) && getDisplayableSlots().length == 0 &&
                    <div className="rtp_no_availability">   
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={rd.strings.attention}>
                            <path d="M12 0C18.6171 0 24 5.38286 24 12C24 18.6171 18.6171 24 12 24C5.38286 24 0 18.6171 0 12C0 5.38286 5.38286 0 12 0ZM12 1.14258C6.01371 1.14258 1.14258 6.01371 1.14258 12C1.14258 17.9863 6.01371 22.8574 12 22.8574C17.9863 22.8574 22.8574 17.9863 22.8574 12C22.8574 6.01371 17.9863 1.14258 12 1.14258ZM12.5713 19.4287H11.4287V17.1426H12.5713V19.4287ZM12.5713 14.8574H11.4287V4.57129H12.5713V14.8574Z" fill={primaryBtnColor}/>
                        </svg>

                        <span className="rtp_no_avail_msg"  tabIndex="0">{rd.strings.noAvailability}</span>
                    </div>
                }

                {
                    availabilityCheckResponse && availabilityCheckResponse.result == 1 && Array.isArray(availabilityCheckResponse.timeslots) && getDisplayableSlots().length > 0 &&
                    <>
                        <div className="rtp_title_row slots_title" >
                            <span>{reservationData.strings.timeListLabel}</span>

                            <div className="rtp_slot_page_controls" style={{display:getDisplayableSlots().length > slotsPerPage ? 'flex' : 'none'}}>
                                <svg className={"rtp_pre_slot_page " + _getPreSlotPageClass()} onClick={onPreSlotPageClick}
                                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onPreSlotPageClick(e); } }}
                                    width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg"
                                    tabIndex="0" role="button" aria-label={rd.strings.previousPage}
                                >
                                    <rect x="28.5" y="28.4713" width="27" height="27" rx="13.5" transform="rotate(-180 28.5 28.4713)" stroke="#141413"/>
                                    <path d="M17 19.9713L12 14.9713L17 9.97127" stroke="#141413" strokeWidth="1.75"/>
                                </svg>

                                <svg className={"rtp_next_slot_page " + _getNextSlotPageClass()} onClick={onNextSlotPageClick}
                                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onNextSlotPageClick(e); } }}
                                    width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg"
                                    tabIndex="0" role="button" aria-label={rd.strings.nextPage}
                                >
                                    <rect x="0.5" y="1.47127" width="27" height="27" rx="13.5" stroke="#141413"/>
                                    <path d="M12 9.97127L17 14.9713L12 19.9713" stroke="#141413" strokeWidth="1.75"/>
                                </svg>
                            </div>
                        </div>

                        <div className="rtp_timeslots_div">
                            {
                               getCurrentPageSlots().map(
                                    (slot, pageIndex) => {
                                        const slotDisplayName = getSlotDisplayName(slot);
                                        return(
                                            <button type="button" className={'timeslot_btn clean_button ' + SG.BD_PRIMARY + '  ' + SG.RC_BD_RADIUS + ' ' + SG.F_BODY} 
                                                key={getSlotIdentifier(slot)} data-timeslot={getSlotIdentifier(slot)} data-menuid={slot.menu_id || ''}
                                                onClick={timeClicked} style={_getTimeSlotCssForCurrentPage(slot, selectedTime, pageIndex)}
                                            >
                                                {enable7RExclusivity && isSevenRoomsProgram && isTimeSlotExclusive(slot) &&
                                                    <span className="rtp_exclusive_timeslot" style={{backgroundColor: reservationData.siteColors.primaryButtonBackground || reservationData.siteColors.primary}}>
                                                        <img src="/images/svg/diamond.svg" />
                                                    </span>
                                                }
                                                <span className="rtp_slot_time">{getTimeDisplay(slot.time_slot_iso, slot.time_display)}</span>
                                                {slotDisplayName && <span className="rtp_seating_area_name">{slotDisplayName}</span>}
                                            </button>
                                        )
                                    }
                                )
                            }
                        </div>

                        {getSelectedSlotMenus() &&
                            <div className="rtp_menu_section">
                                {getSelectedSlotMenus().length === 1 ? (
                                    <div className={'rtp_menu_item ' + SG.RC_BD_RADIUS} style={{borderColor: primaryBtnColor, background: primaryBtnColor + '10', cursor: 'default'}}>
                                        <div className={'rtp_menu_item_name ' + SG.F_BODY}>{getSelectedSlotMenus()[0].name}</div>
                                        {(getSelectedSlotMenus()[0].description || getSelectedSlotMenus()[0].menu_url) && (
                                            <div className="rtp_menu_item_desc_wrap">
                                                {getSelectedSlotMenus()[0].description && (
                                                    <p className="rtp_menu_item_desc expanded">{getSelectedSlotMenus()[0].description.replace(/\n{2,}/g, '\n')}</p>
                                                )}
                                                {getSelectedSlotMenus()[0].menu_url && (
                                                    <div className="rtp_menu_item_desc_actions">
                                                        <span />
                                                        <a href={getSelectedSlotMenus()[0].menu_url} target="_blank" rel="noopener noreferrer" className="rtp_menu_item_link" aria-label={(rd.strings.menuViewMenuLabel || 'View Menu') + ' (opens in a new tab)'}>
                                                            {rd.strings.menuViewMenuLabel || 'View Menu'}
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">
                                                                <path fillRule="evenodd" clipRule="evenodd" d="M6.75 1.11759e-07L9.375 0C9.47446 0 9.56984 0.0395088 9.64017 0.109835C9.71049 0.180161 9.75 0.275544 9.75 0.375V3C9.75 3.20711 9.58211 3.375 9.375 3.375C9.16789 3.375 9 3.20711 9 3V1.28033L2.89016 7.39017C2.74372 7.53661 2.50628 7.53661 2.35984 7.39017C2.21339 7.24372 2.21339 7.00628 2.35984 6.85983L8.46967 0.75L6.75 0.75C6.54289 0.75 6.375 0.582107 6.375 0.375C6.375 0.167893 6.54289 1.3411e-07 6.75 1.11759e-07ZM1.5 2.25C1.08579 2.25 0.75 2.58579 0.75 3V8.25C0.75 8.66421 1.08579 9 1.5 9H6.75C7.16421 9 7.5 8.66421 7.5 8.25V4.125C7.5 3.91789 7.66789 3.75 7.875 3.75C8.08211 3.75 8.25 3.91789 8.25 4.125V8.25C8.25 9.07843 7.57843 9.75 6.75 9.75H1.5C0.671573 9.75 0 9.07843 0 8.25V3C0 2.17157 0.671573 1.5 1.5 1.5H5.625C5.83211 1.5 6 1.66789 6 1.875C6 2.08211 5.83211 2.25 5.625 2.25H1.5Z" fill="#141413"/>
                                                            </svg>
                                                        </a>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                ) : selectedMenuId ? (
                                    <button type="button" className={'rtp_menu_selected_row clean_button ' + SG.F_BODY} style={{borderColor: primaryBtnColor, background: primaryBtnColor + '1A'}} onClick={onOpenMenuModal}
                                        aria-label={'Change menu selection: ' + (getSelectedSlotMenus().find(m => String(m.id) === selectedMenuId)?.name || '')}>
                                        <span className="rtp_menu_selected_name">
                                            {getSelectedSlotMenus().find(m => String(m.id) === selectedMenuId)?.name || ''}
                                        </span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M13.7803 2.21967C13.4874 1.92678 13.0126 1.92678 12.7197 2.21967L11.9482 2.99111L13.0089 4.05177L13.7803 3.28033C14.0732 2.98744 14.0732 2.51256 13.7803 2.21967ZM12.3018 4.75888L11.2411 3.69822L5.64057 9.29877C5.34686 9.59248 5.13096 9.95474 5.01238 10.3528L4.74306 11.2569L5.64718 10.9876C6.04527 10.869 6.40753 10.6531 6.70124 10.3594L12.3018 4.75888ZM12.0126 1.51256C12.696 0.829146 13.804 0.829146 14.4874 1.51256C15.1709 2.19598 15.1709 3.30402 14.4874 3.98744L7.40834 11.0665C6.99715 11.4777 6.48998 11.78 5.93267 11.946L4.14274 12.4792C3.96679 12.5316 3.77627 12.4834 3.64645 12.3535C3.51663 12.2237 3.4684 12.0332 3.52081 11.8573L4.054 10.0673C4.22001 9.51003 4.52227 9.00286 4.93346 8.59167L12.0126 1.51256ZM3.5 4.49999C2.94772 4.49999 2.5 4.94771 2.5 5.49999V12.5C2.5 13.0523 2.94772 13.5 3.5 13.5H10.5C11.0523 13.5 11.5 13.0523 11.5 12.5V9.33333C11.5 9.05719 11.7239 8.83333 12 8.83333C12.2761 8.83333 12.5 9.05719 12.5 9.33333V12.5C12.5 13.6046 11.6046 14.5 10.5 14.5H3.5C2.39543 14.5 1.5 13.6046 1.5 12.5V5.49999C1.5 4.39542 2.39543 3.49999 3.5 3.49999H6.66667C6.94281 3.49999 7.16667 3.72385 7.16667 3.99999C7.16667 4.27614 6.94281 4.49999 6.66667 4.49999H3.5Z" fill="#141413"/>
                                        </svg>
                                    </button>
                                ) : (
                                    <button type="button" className={'rtp_menu_trigger_btn clean_button ' + SG.F_BODY} style={{borderColor: primaryBtnColor, color: primaryBtnColor}} onClick={onOpenMenuModal}
                                        aria-label={rd.strings.menuSelectLabel || 'Select a menu'}>
                                        {rd.strings.menuSelectLabel || 'Select a menu'}
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                            <circle cx="10" cy="10" r="9" stroke={primaryBtnColor} strokeWidth="1.5"/>
                                            <path d="M10 6V14M6 10H14" stroke={primaryBtnColor} strokeWidth="1.5" strokeLinecap="round"/>
                                        </svg>
                                    </button>
                                )}
                            </div>
                        }

                        {showMenuModal && getSelectedSlotMenus() &&
                            <div className="rtp_menu_modal_overlay rtp_overlay ifonly_overlay" style={{display: 'block'}} onKeyDown={onMenuModalKeyDown}>
                                <div className={'rtp_menu_modal ifonly_pop ' + SG.RC_BD_RADIUS} role="dialog" aria-modal="true" aria-label={rd.strings.availableMenusTitle || 'Available Menus'} ref={menuModalRef}>
                                    <button type="button" className="closebtn" onClick={onCloseMenuModal} aria-label="Close Menu Selection" autoFocus>
                                        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M16.2208 1.38562L9.60463 8.078L16.2208 14.7714L15.1154 15.8885L8.49916 9.19519L1.88393 15.8885L0.779434 14.7714L7.39467 8.078L0.779434 1.38562L1.88393 0.267456L8.49916 6.95984L15.1154 0.267456L16.2208 1.38562Z" fill="#141413"/>
                                        </svg>
                                    </button>

                                    <div className={'rtp_menu_modal_title ' + SG.F_BODY}>{rd.strings.availableMenusTitle || 'Available Menus'}</div>

                                    <div className="rtp_menu_list" role="radiogroup">
                                        {getSelectedSlotMenus().map((menu) => {
                                            const isSelected = pendingMenuId === String(menu.id);
                                            return (
                                                <div
                                                    key={'menu_item_' + menu.id}
                                                    className={'rtp_menu_item ' + SG.RC_BD_RADIUS + (isSelected ? ' selected' : '')}
                                                    style={isSelected ? {borderColor: primaryBtnColor, background: primaryBtnColor + '10'} : {}}
                                                    onClick={() => setPendingMenuId(String(menu.id))}
                                                    role="radio"
                                                    aria-checked={isSelected}
                                                    tabIndex="0"
                                                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setPendingMenuId(String(menu.id)); } }}
                                                >
                                                    <div className={'rtp_menu_item_name ' + SG.F_BODY}>{menu.name}</div>
                                                    {(menu.description || menu.menu_url) && (
                                                        <div className="rtp_menu_item_desc_wrap">
                                                            {menu.description && (
                                                                <p
                                                                    className={'rtp_menu_item_desc' + (expandedMenuDescs[menu.id] ? ' expanded' : '')}
                                                                    ref={(el) => {
                                                                        if (el && !(menu.id in descOverflows)) {
                                                                            setDescOverflows(prev => ({...prev, [menu.id]: el.scrollHeight > el.clientHeight}));
                                                                        }
                                                                    }}
                                                                >{menu.description.replace(/\n{2,}/g, '\n')}</p>
                                                            )}
                                                            {(descOverflows[menu.id] || menu.menu_url) && (
                                                                <div className="rtp_menu_item_desc_actions">
                                                                    {descOverflows[menu.id] ? (
                                                                        <button
                                                                            type="button"
                                                                            className="rtp_menu_desc_toggle"
                                                                            onClick={(e) => { e.stopPropagation(); setExpandedMenuDescs(prev => ({...prev, [menu.id]: !prev[menu.id]})); }}
                                                                            onKeyDown={(e) => e.stopPropagation()}
                                                                        >
                                                                            {expandedMenuDescs[menu.id] ? (rd.strings.menuViewLessLabel || 'View less') : (rd.strings.menuViewMoreLabel || 'View more')}
                                                                            <svg className="rtp_menu_desc_arrow" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" style={{transform: expandedMenuDescs[menu.id] ? 'rotate(180deg)' : 'rotate(0deg)'}}>
                                                                                <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                                            </svg>
                                                                        </button>
                                                                    ) : <span />}
                                                                    {menu.menu_url && (
                                                                        <a href={menu.menu_url} target="_blank" rel="noopener noreferrer" className="rtp_menu_item_link" onClick={e => e.stopPropagation()} onKeyDown={(e) => e.stopPropagation()} aria-label={(rd.strings.menuViewMenuLabel || 'View Menu') + ' (opens in a new tab)'}>
                                                                            {rd.strings.menuViewMenuLabel || 'View Menu'}
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                                                                <path fillRule="evenodd" clipRule="evenodd" d="M6.75 1.11759e-07L9.375 0C9.47446 0 9.56984 0.0395088 9.64017 0.109835C9.71049 0.180161 9.75 0.275544 9.75 0.375V3C9.75 3.20711 9.58211 3.375 9.375 3.375C9.16789 3.375 9 3.20711 9 3V1.28033L2.89016 7.39017C2.74372 7.53661 2.50628 7.53661 2.35984 7.39017C2.21339 7.24372 2.21339 7.00628 2.35984 6.85983L8.46967 0.75L6.75 0.75C6.54289 0.75 6.375 0.582107 6.375 0.375C6.375 0.167893 6.54289 1.3411e-07 6.75 1.11759e-07ZM1.5 2.25C1.08579 2.25 0.75 2.58579 0.75 3V8.25C0.75 8.66421 1.08579 9 1.5 9H6.75C7.16421 9 7.5 8.66421 7.5 8.25V4.125C7.5 3.91789 7.66789 3.75 7.875 3.75C8.08211 3.75 8.25 3.91789 8.25 4.125V8.25C8.25 9.07843 7.57843 9.75 6.75 9.75H1.5C0.671573 9.75 0 9.07843 0 8.25V3C0 2.17157 0.671573 1.5 1.5 1.5H5.625C5.83211 1.5 6 1.66789 6 1.875C6 2.08211 5.83211 2.25 5.625 2.25H1.5Z" fill="#141413"/>
                                                                            </svg>
                                                                        </a>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>

                                    <div className="btn_row">
                                        <button
                                            type="button"
                                            className={'rtp_menu_confirm_btn ' + SG.BD_PRIMARY + ' ' + SG.RC_BD_RADIUS + ' ' + SG.F_BODY}
                                            style={pendingMenuId ? btnStyle : {opacity: 0.5, cursor: 'not-allowed', backgroundColor: primaryBtnColor, color: primaryBtnFontColor}}
                                            disabled={!pendingMenuId}
                                            onClick={onConfirmMenuSelection}
                                        >
                                            {rd.strings.menuConfirmLabel || 'Confirm Selection'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        }
                        {enable7RExclusivity && isSevenRoomsProgram && availabilityCheckResponse?.timeslots?.some(isTimeSlotExclusive) &&
                            <div className="rtp_exclusive_timeslot_legend">
                                <img src="/images/svg/diamond.svg" className='rtp_exclusive_timeslot_legend_wrapper' style={{"marginTop":"4px", "backgroundColor": reservationData.siteColors.primaryButtonBackground || reservationData.siteColors.primary}}/>
                                <span>{reservationData.strings.exclusiveTimeSlotLegend}</span>
                            </div>
                        }
                    </>
                }

                {
                    (reservationData.hintTextBoxRequired == '1') &&
                    <>
                        <div className="rtp_title_row" style={{paddingBottom: '10px'}} >
                            {reservationData.strings.hintText}
                        </div>
                        <textarea id="rtp_hint_text_box" name="CartItemSocialInfo[info]" className={'rtp_hint_text_box ' + SG.BD_PRIMARY + '  ' + SG.RC_BD_RADIUS + ' ' + SG.F_BODY} 
                            rows="3"
                        >
                        </textarea>
                    </>
                
                }

                {   /*
                    showConfirmError &&
                    <div className={`rtp_confirm_err_overlay rtp_overlay ifonly_overlay ${SG.F_BODY}`}  style={{display:'block'}}>
                        <div className={`ifonly_pop ${SG.RC_BD_RADIUS}`} >

                            <button type="button" className="closebtn" onClick={onCloseConfirmError}>
                                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16.2208 1.38562L9.60463 8.078L16.2208 14.7714L15.1154 15.8885L8.49916 9.19519L1.88393 15.8885L0.779434 14.7714L7.39467 8.078L0.779434 1.38562L1.88393 0.267456L8.49916 6.95984L15.1154 0.267456L16.2208 1.38562Z" fill="#141413"/>
                                </svg>
                            </button>

                            <div className="rtp_confirm_error_title">{rd.strings.confirmErrorTitle}</div>

                            <div >{rd.strings.confirmErrorText}</div>

                            <div className="btn_row">
                                <button type="button" className={'restaurant_btn ' + SG.BD_PRIMARY } style={btnStyle} onClick={onCloseConfirmError}>
                                    {rd.strings.confirmErrorBtnText}
                                </button>
                            </div>
                        </div>
                    </div>
                    */
                }


                <input type="hidden" className="hidden_selected_date" value={selectedDate} />
                <input type="hidden" name="Schedule[date][0]" className="hidden_selected_time" value={selectedScheduleDateTime} />
                <input type="hidden" name="CartItemSocialInfo[occasion]" value={reservationOccasionMeta} />
                <input type="hidden" name="Schedule[menuId]" value={selectedMenuId} />
                <input type="hidden" name="isExclusiveSlot" value={enable7RExclusivity && isSevenRoomsProgram && selectedSlot && isTimeSlotExclusive(selectedSlot) ? 1: 0} />


                {typeof(localStorage) != 'undefined' && localStorage.rtp_debug == '1' &&
                    <div>
                        numGuest: {numGuest}<br />
                        selected date: {selectedDate} <br />
                        selected time: {selectedTime}
                    </div>
                }

                <style>
                    {'.rtp_spinner::after {background:' + primaryBtnColor + ';}'}
                </style>

                {
                    <div className="rtp_timeslots_loading" style={{display: (isLoading? 'flex' : 'none')}}>
                        <div className='rtp_spinner' style={{background:'conic-gradient( from 90deg at 50% 50%,rgba(39, 174, 96, 0) 0deg, rgba(31, 144, 255, 0) 0.04deg, ' + primaryBtnColor + ' 360deg)'}} />
                        <span className="loading_msg screen-reader-only" role="status" aria-live="assertive" aria-atomic="true"></span>
                    </div>
                }

            </div>

            <Datepicker 
                startDate = {reservationData.startDate}
                endDate = {reservationData.endDate}
                activeStartDate = {reservationData.activeStartDate}
                activeEndDate = {reservationData.activeEndDate}
                activeDates = {{'any':true}}
                monthTexts = {reservationData.monthTexts}
                weekDayTexts = {reservationData.weekDayTexts}
                dateLegnedAvailable = {reservationData.strings.dateLegnedAvailable}
                dateLegnedUnavailable = {reservationData.strings.dateLegnedUnavailable}
                show = {showDatepicker} 
                onClose = {setShowDatepicker}
                onDatePicked = {onDatePicked}
                onOverlayPicked = {onOverlayPicked}
                selectedDate = {selectedDate}
                selectedDateBackgroundColor = {primaryBtnColor}
                selectedDateColor = {primaryBtnFontColor}
            />
        </>
    )
}

export default ReservationTriplePickerRealtime;